/**
 * Created by shahar on 26-Nov-17.
 */

import {Injectable} from "@angular/core";
import {ISystemConfiguration, ISystemConfigurationDetails} from "../interfaces/interfaces";
import {SystemConfigurationService} from "./system.configuration.service";
import {LogManager} from "../../log/log.manager";

/**
 Service class for getting system configuration from server after validity checks.
 */

export type configKey = keyof ISystemConfiguration;

@Injectable({
  providedIn: 'root'
})
export class BaseSystemConfigurationValues {

  private readonly LIST_SEPERATOR = ',';

  constructor(public cfg: SystemConfigurationService) {}

  public getNumber(key: configKey, defaultVal?: number): number {
    let stringVal = this.getValidatedString(key,"" + defaultVal);
    if (isNaN(+stringVal)) {
      let err="cannot parse number value for " + key +". Value is " + stringVal;
      LogManager.error("ConfigItem", err);
      throw new Error(err);
    } else {
      return +stringVal;
    }
  }
  public getBoolean(key: configKey, defaultVal?: boolean): boolean {
    let stringVal = this.getValidatedString(key,"" + defaultVal);
    switch (stringVal.toUpperCase()) {
      case "T":
      case "Y":
      case "TRUE":
      case "YES":
        return true;
      case "F":
      case "N":
      case "FALSE":
      case "NO":
        return false;
      default:{
        throw new Error("cannot parse boolean value for " + key +". Value is " + stringVal);
      }
    }
  }

  public getNumberArray(key: configKey, defaultVal?: string): number[]{
    let stringVal = this.getValidatedString(key, "" + defaultVal);

    if (!stringVal) {
      return [];
    }

    return stringVal.split(this.LIST_SEPERATOR).map(strVal => +strVal);
  }

  public getValidatedString(key: configKey, defaultVal?: string): string {
    let cfgVal: ISystemConfigurationDetails = this.cfg.getConfigByKey(key);

    if (!cfgVal && defaultVal) {
      let err = "invalid cfg requested <"+key+">. value is missing.";
      LogManager.warn("ConfigItem", err);
      return defaultVal;
    }
    if (!cfgVal || cfgVal.status === "NotValid") {
      let err = "invalid cfg requested <"+key+">. value is not valid.";
      LogManager.error("ConfigItem", err);
      if (defaultVal){
        return defaultVal;
      }
      throw new Error(err);
    }
    return cfgVal.value;
  }
}
